<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="transparent" :label="$lang.transparent" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="lightsOut" :label="$lang.lightsOut" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="7" sm24 />
      <flex-col :span="10" sm24>
        <card>
          <card-text :class="['relative']" padding-off>
            <system-bar :app="app" :z-index="100" :transparent="transparent" position="absolute" :class="['top-0', 'left-0']" :lights-out="lightsOut" :rounded="rounded" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null">
              <template v-slot:left>
                <icon name="message" />
                <span :class="['pl-1']" v-html="$lang.unreadMessages()" />
              </template>
              <template v-slot:right>
                <icon name="bluetooth" />
                <icon name="signal" />
                <icon name="wifi" />
                <icon name="battery-50" />
                <time datetime="1234567890">12:30</time>
              </template>
            </system-bar>
            <lazy-image
              :placeholder-bg-color="$dark ? 'black' : 'white'"
              :placeholder-bg-color-lightness="null"
              :placeholder-icon-color="$root.colors.primary"
              :placeholder-icon-color-lightness="$root.colors.bgColorLightness"
              :src="`${$root.config.staticAssetsDir}/images/misc/stormy-weather-at-freshwater-bay.jpg`" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="7" sm24 />
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSystemBar',
  mixins: [
    methods
  ],
  data () {
    return {
      app: false,
      lightsOut: true,
      rounded: false,
      transparent: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/system-bar.vue